module.exports = __webpack_public_path__ + "img/bell-icon.77e8f2b6.svg";